import { lazy, Suspense } from "react";
import SiteHeader from "@/components/SiteHeader";
import HeroSection from "@/components/HeroSection";
import { useSEO } from "@/hooks/useSEO";

const AboutSection = lazy(() => import("@/components/AboutSection"));
const BuySection = lazy(() => import("@/components/BuySection"));
const NewLotsBanner = lazy(() => import("@/components/NewLotsBanner"));
const ReviewsSection = lazy(() => import("@/components/ReviewsSection"));
const TrustSection = lazy(() => import("@/components/TrustSection"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const QuoteForm = lazy(() => import("@/components/QuoteForm"));
const HomeBlogSection = lazy(() => import("@/components/HomeBlogSection"));
const SiteFooter = lazy(() => import("@/components/SiteFooter"));

const Index = () => {
  useSEO({
    title: "Nardy Automation — Industrial Automation Parts In Stock USA",
    description: "New industrial automation parts in stock. PLCs, HMIs, VFDs, and modules ready to ship from the USA. Request a quote today.",
    canonical: "/",
  });

  return (
    <main>
      <SiteHeader />
      <HeroSection />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <AboutSection />
        <BuySection />
        <NewLotsBanner />
        <ReviewsSection />
        <TrustSection />
        <HomeBlogSection />
        <FinalCTA />
        <QuoteForm />
        <SiteFooter />
      </Suspense>
    </main>
  );
};

export default Index;
